//import types from 'actions/types'
import { combineReducers } from 'redux'
import threadTab from './threadTab'

export default combineReducers({
  threadTab,
})
